import React from 'react'
import { Dialog } from '@headlessui/react'
import { XMarkIcon, ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'
import { useTheme } from '../../contexts/ThemeContext'

const PolicyDocumentModal = ({ open, onClose, title, documentUrl }) => {
  const { t } = useTranslation()
  const { darkMode } = useTheme()

  const backdropClass = darkMode ? 'bg-sport-darker/80' : 'bg-gray-900/50'
  const panelClass = darkMode
    ? 'bg-sport-dark/98 border border-sport-silver/20 text-sport-light'
    : 'bg-white border border-gray-200 text-gray-900'
  const mutedClass = darkMode ? 'text-sport-silver/70' : 'text-gray-600'

  return (
    <Dialog open={open} onClose={onClose} className="relative z-[100]">
      <div className={`fixed inset-0 ${backdropClass} backdrop-blur-md`} aria-hidden="true" />

      <div className="fixed inset-0 overflow-y-auto p-4">
        <div className="flex min-h-full items-center justify-center">
          <Dialog.Panel className={`w-full max-w-4xl rounded-2xl shadow-2xl overflow-hidden ${panelClass}`}>
            <div className="flex items-center justify-between gap-3 px-4 py-3 border-b border-sport-primary/15 sm:px-6">
              <Dialog.Title className="text-lg font-semibold pr-2">{title}</Dialog.Title>
              <div className="flex items-center gap-2 shrink-0">
                <a
                  href={documentUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm text-sport-primary hover:text-sport-secondary transition-colors"
                >
                  <ArrowTopRightOnSquareIcon className="h-4 w-4" />
                  <span className="hidden sm:inline">{t('register.openPolicyInNewTab')}</span>
                </a>
                <button
                  type="button"
                  onClick={onClose}
                  className={`p-2 rounded-lg transition ${darkMode ? 'text-sport-silver hover:text-sport-light hover:bg-sport-primary/10' : 'text-gray-500 hover:text-gray-800 hover:bg-gray-100'}`}
                  aria-label={t('common.close')}
                >
                  <XMarkIcon className="h-5 w-5" />
                </button>
              </div>
            </div>

            <div className="p-4 sm:p-6">
              <iframe
                src={documentUrl}
                title={title}
                className={`w-full h-[min(70vh,720px)] rounded-xl border ${darkMode ? 'border-sport-silver/20 bg-white' : 'border-gray-200 bg-gray-50'}`}
              />
              <p className={`mt-3 text-xs ${mutedClass}`}>
                {t('register.policyViewerHint')}
              </p>
            </div>
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  )
}

export default PolicyDocumentModal
